import React, {
    useEffect,
    useRef
}
from "react";


//============================================================
// Mobile Giraffe Viewer
//============================================================

export default function MobileGiraffeViewer(
{
    url,
    onHotspotClick
})
{

    //--------------------------------------------------------
    // Refs
    //--------------------------------------------------------

    const viewerRef =
        useRef(null);


    //--------------------------------------------------------
    // Giraffe messages
    //--------------------------------------------------------

    useEffect(
        function()
        {

            const handleMessage =
                function(event)
                {

                    const tourFrame =
                        viewerRef.current;

                    if(!tourFrame)
                    {
                        return;
                    }

                    if(
                        event.source !==
                        tourFrame.contentWindow
                    )
                    {
                        return;
                    }

                    if(
                        event.data?.type !==
                        "g360:info-hotspot-click"
                    )
                    {
                        return;
                    }

                    const {
                        hotspotId
                    } = event.data;

                    if(onHotspotClick)
                    {
                        onHotspotClick(
                            hotspotId
                        );
                    }

                };


            window.addEventListener(
                "message",
                handleMessage
            );


            return function()
            {

                window.removeEventListener(
                    "message",
                    handleMessage
                );

            };

        },
        [onHotspotClick]
    );


    //========================================================
    // Styles
    //========================================================

    const container =
    {
        position:
            "relative",

        width:
            "100%",

        height:
            "100%",

        overflow:
            "hidden",

        background:
            "#111827"
    };


    const frame =
    {
        display:
            "block",

        width:
            "100%",

        height:
            "100%",

        margin:
            0,

        padding:
            0,

        border:
            "none"
    };


    //========================================================
    // Render
    //========================================================

    return (

        <div style={container}>

            <iframe
                ref={viewerRef}
                src={url}
                title="Building Scan"
                style={frame}
                frameBorder="0"
                allowFullScreen
            />

        </div>

    );

}